export default __webpack_public_path__ + "static/media/Animals_28.810acd25.png";